export default {
  namespaced: true,
  state: () => ({
    boletos: [],
    setIsLoading: false,
    filterList: {},
    pagination: {
      totalItems: 0,
      currentPage: 1,
      perPage: 5,
      totalPages: 0,
    },
  }),
  actions: {},
  mutations: {
    SET_BOLETOS(state, data) {
      state.boletos = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },
    SET_FILTROS(state, data) {
      state.filterList = data;
    },
    SET_PAGINATION(state, data) {
      state.pagination = {
        ...state.pagination,
        ...data,
      };
    },
  },
  getters: {
    getBoletos: (state) => state.boletos,
    getIsLoading: (state) => state.setIsLoading,
    getFilterList: (state) => state.filterList,
    getPagination: (state) => state.pagination,
  },
};
